<div class="container-fluid bg-primary py-4 text-white">
  <div class="row">
    @if (menuData.length > 0) {
      @for (menu of menuData; track menu.title) {
        <app-menu-item [menuItem]="menu"></app-menu-item>
      }
    } @else if (!authService.currentUser) {
      <span class="visually-hidden">Cargando menú</span>
      @for (skeletonWidth of skeletonRows; track $index) {
        <div
          class="col-12 mb-3 px-4 d-flex align-items-center placeholder-glow"
          aria-hidden="true">
          <span class="placeholder placeholder-lg col-1 me-3 rounded bg-light bg-opacity-25"></span>
          <span class="placeholder {{ skeletonWidth }} rounded bg-light bg-opacity-25"></span>
        </div>
      }
    }
  </div>
</div>
